(() => {
  if (window.joffzPremiumEventsReady) return;
  window.joffzPremiumEventsReady = true;
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-joffz-event]');
    if (!link) return;
    const name = `joffz_${link.dataset.joffzEvent}_clicked`;
    const detail = { collection: link.dataset.collection || '', locale: document.documentElement.lang, path: location.pathname };
    document.dispatchEvent(new CustomEvent(name, { detail }));
    try { window.Shopify?.analytics?.publish(name, detail)?.catch?.(() => {}); } catch (_) {}
  });
})();
